'use client'
import { useLanguage } from '@/lib/context/LanguageContext'
import SectionHeader from '@/components/ui/SectionHeader'
import ChannelsHero from './ChannelsHero'
import ChannelsMessengers from './ChannelsMessengers'

export default function Channels() {
  const { t } = useLanguage()
  const c = t.channels

  return (
    <section id="channels" className="py-16 md:py-24 lg:py-32 border-b border-ink/5">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <SectionHeader num="03" label={c.section} />
        <ChannelsHero />
        <ChannelsMessengers />
      </div>
    </section>
  )
}
